import * as React from "react";
const SvgFiRrTreeChristmas = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m20.44 16.855-1.481-2.221a2.215 2.215 0 0 0 .619-3.072l-2.091-3.135q.276-.253.456-.58a2.21 2.21 0 0 0-.084-2.256 1 1 0 0 0-.081-.109L13.678.7a2.38 2.38 0 0 0-3.4.051L6.206 5.478a1 1 0 0 0-.081.107 2.21 2.21 0 0 0 .38 2.853l-2.083 3.124a2.214 2.214 0 0 0 .619 3.072L3.56 16.855A3.309 3.309 0 0 0 6.312 22H11v1a1 1 0 1 0 2 0v-1h4.687a3.31 3.31 0 0 0 2.753-5.145m-1.6 2.454a1.29 1.29 0 0 1-1.153.691H6.312a1.31 1.31 0 0 1-1.088-2.035l2.276-3.41A1 1 0 0 0 6.666 13h-.405a.2.2 0 0 1-.186-.111.2.2 0 0 1 .011-.217l2.745-4.117a1 1 0 0 0-.334-1.413A1 1 0 0 0 7.98 7a.2.2 0 0 1-.186-.11.2.2 0 0 1-.011-.178l3.962-4.6a.327.327 0 0 1 .464-.052L16.2 6.713a.2.2 0 0 1-.011.178A.2.2 0 0 1 16 7a1 1 0 0 0-.832 1.555l2.745 4.117a.2.2 0 0 1 .011.217.2.2 0 0 1-.186.111h-.405a1 1 0 0 0-.832 1.555l2.274 3.41a1.29 1.29 0 0 1 .065 1.344"
    />
    <path
      fill="#062147"
      d="M9 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2M14 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2M11 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2M13 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M11 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
  </svg>
);
export default SvgFiRrTreeChristmas;
